export default class ComponentConfig {
    allowChatBot:boolean = false;
    allowAgentChat:boolean = false;
    queue:string = ''; // 'fake' for local dev
    useLocalResources:boolean = false; // true for local dev
    botChatId: string|null = null;
    agentChatId: string|null = null;
    forceAgentChat:boolean = false;
    userNameRequired: boolean = false;
    showCloseContent: boolean = false;
    showMessageContent: boolean = false;
    entryPoint: string = '';
    entryPointPath: string = '';
    client: string = 'Web'; // 'fake' for local dev
    appUserAgent: string = '';
    startQuestion: string|null = null;
    renewSession?: () => void;

    setConfig(config:any):void {
        if (config.allowChatBot && typeof config.allowChatBot === "boolean") {
            this.allowChatBot = config.allowChatBot;
        }
        if (config.allowAgentChat && typeof config.allowAgentChat === "boolean") {
            this.allowAgentChat = config.allowAgentChat;
        }
        if (config.queue && typeof config.queue === "string") {
            this.queue = config.queue;
        }
        if (config.botChatId && typeof config.botChatId === "string") {
            this.botChatId = config.botChatId;
        }
        if (config.agentChatId && typeof config.agentChatId === "string") {
            this.agentChatId = config.agentChatId;
        }
        if (config.forceAgentChat && typeof config.forceAgentChat === "boolean") {
            this.forceAgentChat = config.forceAgentChat;
        }
        if (config.userNameRequired && typeof config.userNameRequired === "boolean") {
            this.userNameRequired = config.userNameRequired;
        }
        if (config.showCloseContent && typeof config.showCloseContent === "boolean") {
            this.showCloseContent = config.showCloseContent;
        }
        if (config.showMessageContent && typeof config.showMessageContent === "boolean") {
            this.showMessageContent = config.showMessageContent;
        }
        if (config.useLocalResources && typeof config.useLocalResources === "boolean") {
            this.useLocalResources = config.useLocalResources;
        }
        if (config.entryPoint && typeof config.entryPoint === "string") {
            this.entryPoint = config.entryPoint;
        }
        if (config.entryPointPath && typeof config.entryPointPath === "string") {
            this.entryPointPath = config.entryPointPath;
        }
        if (config.renewSession && typeof config.renewSession === "function") {
            this.renewSession = config.renewSession;
        }
        if (config.client && typeof config.client === "string") {
            this.client = config.client;
        }
        if (config.appUserAgent && typeof config.appUserAgent === "string") {
            this.appUserAgent = config.appUserAgent;
        }
        if (config.xAppUserAgent && typeof config.xAppUserAgent === "string") {
            this.appUserAgent = config.xAppUserAgent;
        }
        if (config['x-app-user-agent'] && typeof config['x-app-user-agent'] === "string") {
            this.appUserAgent = config['x-app-user-agent'];
        }
        if (config.startQuestion && typeof config.startQuestion === "string") {
            this.startQuestion = config.startQuestion;
        }
    }

    setAgentChatId(agentChatId: string|null): void {
        this.agentChatId = agentChatId;
    }

    getAgentChatId(): string|null {
        return this.agentChatId;
    }

    setBotChatId(botChatId: string|null): void {
        this.botChatId = botChatId;
    }

    getBotChatId(): string|null {
        return this.botChatId;
    }


}
